import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';

export default function ContactDBFilterReducer(state = initialstate.contactDBFilters, action) {
	switch (action.type) {
		case types.SET_CONTACTSDB_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}

			let filters;
			filters = {...state};
			if (action.filterItemName) {
				filters[action.filterItemName] = value;
			}

			return {
				...state,
				...filters
			};
		}
		case types.CLEAR_CONTACTSDB_FILTER: {
			return initialstate.contactDBFilters;
		}

		default:
			return state;
	}
}
